export const CATEGORIES = [
  { id: 'all', label: 'All' },
  { id: 'classic', label: 'Classic' },
  { id: 'ancient', label: 'Ancient & Cultural' }, // Omweso/Mancala
  { id: 'travel', label: 'Travel' },
  { id: 'party', label: 'Party & Family' }, // Ludo, Jenga
  { id: 'custom', label: 'Custom' },
];

export const ORDER_LINKS = {
  whatsappNumber: process.env.REACT_APP_WHATSAPP_NUMBER,
  instagram: `https://instagram.com/${process.env.REACT_APP_INSTAGRAM_USERNAME}`,
  telegram: `https://t.me/${process.env.REACT_APP_TELEGRAM_USERNAME}`,
};
